module.exports = __webpack_public_path__ + "img/info_donnees_meteo_france.2419c238.jpg";